import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../services/api';

function Dashboard() {
  const [servers, setServers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadServers();
    const interval = setInterval(loadServers, 5000);
    return () => clearInterval(interval);
  }, []);

  async function loadServers() {
    try {
      const data = await api.getServers();
      setServers(data);
    } catch (e) {
      console.error('Failed to load servers:', e);
    } finally {
      setLoading(false);
    }
  }

  const runningServers = servers.filter(s => s.status === 'running');
  const totalPlayers = servers.reduce((sum, s) => sum + (s.players?.length || 0), 0);

  if (loading) {
    return (
      <div className="empty-state">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h2>Dashboard</h2>
      </div>

      <div className="grid grid-4">
        <div className="stat-card">
          <div className="stat-icon">&#127981;</div>
          <div className="stat-value">{servers.length}</div>
          <div className="stat-label">Server gesamt</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">&#9989;</div>
          <div className="stat-value">{runningServers.length}</div>
          <div className="stat-label">Server online</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">&#128100;</div>
          <div className="stat-value">{totalPlayers}</div>
          <div className="stat-label">Spieler online</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">&#128308;</div>
          <div className="stat-value">{servers.length - runningServers.length}</div>
          <div className="stat-label">Server offline</div>
        </div>
      </div>

      <div style={{ marginTop: '24px' }}>
        <div className="card-header">
          <h3>Server-Uebersicht</h3>
          <Link to="/servers" className="btn btn-primary btn-sm">Alle Server</Link>
        </div>

        {servers.length === 0 ? (
          <div className="empty-state">
            <div className="icon">&#127981;</div>
            <p>Noch keine Server konfiguriert</p>
            <Link to="/servers" className="btn btn-primary">Server erstellen</Link>
          </div>
        ) : (
          <div className="grid grid-3" style={{ marginTop: '12px' }}>
            {servers.map(server => (
              <Link key={server.id} to={`/servers/${server.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="server-card">
                  <div className="flex items-center justify-between">
                    <span className="server-name">{server.name}</span>
                    <span className={`status-badge ${server.status}`}>
                      <span className="status-dot" />
                      {server.status}
                    </span>
                  </div>
                  <div className="server-meta">
                    <span>Port: {server.port}</span>
                    <span>RAM: {server.maxRam}</span>
                    <span>Spieler: {server.players?.length || 0}</span>
                  </div>
                  {server.uptime > 0 && (
                    <div className="text-sm text-muted mt-2">
                      Uptime: {formatUptime(server.uptime)}
                    </div>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function formatUptime(ms) {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days}d ${hours % 24}h ${minutes % 60}m`;
  if (hours > 0) return `${hours}h ${minutes % 60}m`;
  return `${minutes}m`;
}

export default Dashboard;
